class SinglePairSelector extends window.BAO.CustomElement({
  SuperClass: HTMLFieldSetElement,
}) {
  static get requiredElements () {
    return ['input']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'input', this.handleInput.bind(this))
  }

  /** @param {InputEvent} event */
  handleInput (event) {
    this.moveBackgroundToOption(event.target)

    const quantity = Number(event.target.value)

    this.dispatchEvent(
      new CustomEvent('single-pair-selector:quantity-change', {
        bubbles: true,
        detail: {
          formId: this.getAttribute('form-id'),
          quantity,
        },
      }),
    )

    this.dispatchEvent(
      new CustomEvent('product-price:update', {
        bubbles: true,
        detail: { quantity },
      }),
    )
  }

  /** @param {HTMLInputElement} option */
  moveBackgroundToOption (option) {
    const optionIndex = this.els.input.elements.findIndex(
      input => input === option,
    )

    if (optionIndex === -1) {
      return
    }

    this.style.setProperty('--SinglePairSelector_SelectedIndex', optionIndex)
  }

  /** @param {number | string} value */
  setValue (value) {
    const optionWithValue = this.els.input.elements.find(
      input => input.value === String(value),
    )

    if (!optionWithValue || optionWithValue.checked) {
      return
    }

    optionWithValue.checked = true
    optionWithValue.dispatchEvent(
      new Event('input', { bubbles: true, cancelable: false }),
    )
  }
}

if (!customElements.get('single-pair-selector')) {
  customElements.define('single-pair-selector', SinglePairSelector, {
    extends: 'fieldset',
  })
}

class SinglePairSelectDropown extends window.BAO.CustomElement({
  SuperClass: HTMLSelectElement,
}) {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'input', this.handleInput.bind(this))
  }

  handleInput () {
    this.dispatchEvent(
      new CustomEvent('single-pair-selector:quantity-change', {
        bubbles: true,
        detail: {
          formId: this.getAttribute('form-id'),
          quantity: Number(this.value),
        },
      }),
    )
  }

  /** @param {number | string} value */
  setValue (value) {
    const valueAsString = String(value)

    if (this.value === valueAsString) {
      return
    }

    this.value = valueAsString
  }
}

if (!window.customElements.get('single-pair-select-dropdown')) {
  window.customElements.define(
    'single-pair-select-dropdown',
    SinglePairSelectDropown,
    { extends: 'select' },
  )
}
